import React, { ElementType, useEffect, useRef } from "react";
import { createSafeContentNode } from "./createSafeContentNode";
import { Content, ContentNode, parseHtml } from "./parseHtml";
import { store } from "@/store";

// This component is can render user configured and potentially unsafe html content.
// The content is sanitized and only allowed tags and attributes are rendered.
export function DynamicContent<E extends ElementType = ElementType, P = {}>({
  content,
  is,
  ...rest
}: { content?: string; is?: E } & React.HTMLAttributes<HTMLDivElement> & P) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    el.innerHTML = "";

    if (content) {
      const ast = parseHtml(content, (url) => store.assetManager.getAsset(url).url);
      const contentNode = createSafeContentNode(ast);
      if (contentNode) {
        el.appendChild(contentNode);
      }
    }
  }, [content]);

  return React.createElement(is ?? "div", { ref: containerRef, "data-pyne-dynamic-content": "", ...rest });
}
